/**
 * Delete Product Use Case
 *
 * Business logic for deleting a product following clean architecture principles.
 * Handles product deletion with proper validation.
 *
 * @module DeleteProductUseCase
 */

import {ProductRepository} from '../repository/ProductRepository';

export class DeleteProductUseCase {
  constructor (private productRepository: ProductRepository) {}

  /**
   * Execute product deletion
   * @param id - Product ID to delete
   * @returns Promise<void>
   */
  async execute (id: number): Promise<void> {
    // Validate ID
    this.validateId(id);

    // Delete product through repository
    await this.productRepository.deleteProduct(id);
  }

  /**
   * Validate product ID
   * @param id - Product ID to validate
   * @throws Error if validation fails
   */
  private validateId (id: number): void {
    if (!id || isNaN(id) || id <= 0) {
      throw new Error('معرف المنتج غير صحيح');
    }
  }
}

